<template lang="pug">
  ProgramSettingsFormWrapper#general-settings(
    setting-type="settings"
    :form-data="formData"
    :disable-save.sync="disableSave"
    @reset="resetTimezone"
    :keys-to-reset="['name']"
    title="General"
  )
    ContentLoader(:width="300" :height="120" v-if="!programLoaded")
      rect(x="0", y="0", rx="4", ry="4", width="45%", height="100")
      rect(x="50%", y="0", rx="4", ry="4", width="50%", height="30")
      rect(x="50%", y="45", rx="4", ry="4", width="50%", height="30")
      rect(x="50%", y="90", rx="4", ry="4", width="50%", height="30")

    .columns(v-else)
      .column
        //- TODO don't want UniquenessCheck with starting value to trigger validation, v-if is a workaround
        UniquenessCheck(
          label="Program Name"
          entity="programName"
          placeholder="Program Name"
          v-model="name"
          @validName="disableSave = !$event"
        )
        BField
          WtLabel(
            slot="label"
            text="Default Timezone"
            tooltip-text="Members are able to change their individual timezone in their settings panel."
            label-for="timezone"
          )
          WtTimezoneSelect(
            :timezone="timezone"
            :initial-offset="programSettingsCopy.timezone"
            @update="updateTimezone($event)"
          )
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ContentLoader } from "vue-content-loader";
import programSettingsFormMixin from "@/mixins/programSettingsFormMixin";
import WtTimezoneSelect from "@@/WtTimezoneSelect/WtTimezoneSelect";
import UniquenessCheck from "@@/WtUniquenessCheckInput/WtUniquenessCheckInput";
import WtLabel from "@@/WtLabel/WtLabel";
import ProgramSettingsFormWrapper from "./ProgramSettingsFormWrapper";

export default {
  name: "GeneralSettings",

  components: {
    WtLabel,
    ProgramSettingsFormWrapper,
    ContentLoader,
    WtTimezoneSelect,
    UniquenessCheck
  },

  mixins: [programSettingsFormMixin],

  data() {
    return {
      timezone: {},
      originalTimezone: null
    };
  },

  computed: {
    ...mapGetters("program", [
      "programSettingsCopy",
      "programLoaded",
      "isProTier"
    ]),

    formData() {
      const data = {
        timezone: this.timezone.value
      };

      if (!this.isOriginalValue("name", this.name)) {
        data.name = this.name;
      }

      return data;
    },

    name: {
      set(name) {
        this.updateProgramSettingsCopy({ key: "name", value: name });
      },
      get() {
        return this.programSettingsCopy.name;
      }
    }
  },

  watch: {
    timezone(newTimezone) {
      if (this.originalTimezone) {
        return;
      }

      this.originalTimezone = newTimezone;
    }
  },

  methods: {
    ...mapActions("program", ["updateCoreMeta", "updateProgramSettingsCopy"]),
    ...mapActions(["snackBar"]),

    updateTimezone(timezone) {
      if (!timezone) return this.resetTimezone();
      this.timezone = timezone;
      this.disableSave = this.isOriginalValue("timezone", timezone.value);
    },

    resetTimezone() {
      this.timezone = this.originalTimezone;
      this.disableSave = true;
    }
  }
};
</script>
